import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles, Box, Paper, Button, Typography } from "@material-ui/core";

import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { ThemeContext } from "../context/Theme/ThemeContext";
import StatesMain from "./StatesMain";
import { useLocalStorage } from "../hooks/useLocalStorage";
import AppLayoutShell from "./app/AppLayoutShell";
import api from "../services/api";
import toastError from "../errors/toastError";

const useStyles = makeStyles((theme) => ({
	socketOverlay: {
		position: "fixed",
		width: "100vw",
		height: "100vh",
		zIndex: 9999999,
		background: "rgba(255, 255, 255, 0.2)",
		backdropFilter: "blur(5px)",
	},
	socketPaper: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		padding: "1em 3em",
		width: "80%",
		maxWidth: "400px",
		textAlign: "center",
	},
}));

function LoggedInLayout({ children }) {
	const classes = useStyles();
	const [userModalOpen, setUserModalOpen] = useState(false);
	const { handleLogout, loading, user, isSocketConnected } = useContext(AuthContext);
	const { darkMode, setDarkMode } = useContext(ThemeContext);
	const [statesMain, setStatesMain] = useLocalStorage("administracao", false);
	const location = useLocation();

	useEffect(() => {
		setStatesMain(true);
	}, [location.pathname, setStatesMain]);

	useEffect(() => {
		if (localStorage.getItem("administracao") === null) {
			setStatesMain(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- apenas na montagem
	}, []);

	useEffect(() => {
		if (document.body.offsetWidth > 600) {
			api.get("/settings").catch((err) => toastError(err));
		}
	}, []);

	const updateUserStatus = (status) => {
		if (!user) return;
		api.put(`/users/${user.id}`, { status }).catch((err) => toastError(err));
	};

	const drawerClose = () => {
		if (document.body.offsetWidth < 1024) {
			/* fechamento mobile tratado pelo shell */
		}
	};

	if (loading) {
		return <BackdropLoading />;
	}

	const mainContent = statesMain ? children || null : <StatesMain />;

	return (
		<>
			{!isSocketConnected && (
				<Box className={classes.socketOverlay}>
					<Paper className={classes.socketPaper}>
						<Typography
							variant="h6"
							style={{
								fontWeight: "bold",
								marginBottom: "1em",
								textTransform: "uppercase",
							}}
						>
							Sessão finalizada
						</Typography>
						<Typography variant="body1">
							Este usuário foi acessado em outra aba do navegador ou dispositivo.
						</Typography>
						<Button
							variant="contained"
							color="primary"
							style={{ marginTop: "1em" }}
							onClick={() => {
								window.location.href = "/";
							}}
						>
							Reconectar
						</Button>
					</Paper>
				</Box>
			)}

			<AppLayoutShell
				darkMode={darkMode}
				user={user}
				statesMain={statesMain}
				onToggleAdmin={() => setStatesMain(!statesMain)}
				onNavClick={() => setStatesMain(true)}
				drawerClose={drawerClose}
				onToggleDarkMode={() => setDarkMode(!darkMode)}
				onOpenAccount={() => setUserModalOpen(true)}
				onLogout={handleLogout}
				onUpdateStatus={updateUserStatus}
				mainContent={mainContent}
			>
				<UserModal
					open={userModalOpen}
					onClose={() => setUserModalOpen(false)}
					userId={user?.id}
				/>
			</AppLayoutShell>
		</>
	);
}

export default LoggedInLayout;
